import { Routes } from '@angular/router';
import { authenticatedRouteGuards, canActivateUser } from '@shared/guard/guard';
import { PageKey } from '@shared/services/page/models/page.key';

export const userRoute: Routes = [
  {
    path: 'users',
    loadComponent: () => import('@user/pages/list/list.component').then(m => m.ListComponent),
    canActivate: [...authenticatedRouteGuards, canActivateUser],
    data: {
      title: 'Usuários',
      key: PageKey.USERS
    }
  }
];
